import { createStore } from "@ice/store"
import global from "./globalModel";
import { nav } from "./navModel";
import { menuState } from "./menuStateModel";

import material from "../pages/base/material/materialModel";
import warehouse from "../pages/base/warehouse/warehouseModel";
import supplier from "../pages/base/supplier/supplierModel";
import customer from "../pages/base/customer/customerModel";
import dict from "../pages/base/dict/dictModel";
import cmDict from "./cmDictModel";

import supplierBill from "../pages/bill/supplier/supplierBillModel";
import customerBill from "../pages/bill/customer/customerBillModel";

import stockCheck from "../pages/stock/check/stockCheckModel";
import stockStatistic from "../pages/stock/statistic/stockStatisticModel";

import purchaseOrder from "../pages/purchase/order/purchaseOrderModel";
import purchaseInvoice from "../pages/purchase/invoice/purchaseInvoiceModel";
import purchasePo from "../pages/purchase/po/purchasePoModel";
import purchaseRo from "../pages/purchase/ro/purchaseRoModel";


import saleOrder from "../pages/sale/order/saleOrderModel";
import saleSo from "../pages/sale/so/saleSoModel";
import saleRo from "../pages/sale/ro/saleRoModel";

import partDealModel from "../pages/statistics/partDeal/partDealModel";
import dinoutModel from "../pages/statistics/dinout/dinoutModel";
import customerSaleModel from "../pages/statistics/customerSale/customerSaleModel";
import supplierModel from "../pages/statistics/supplier/supplierModel";
import partOrCustomerModel from "../pages/statistics/partOrCustomer/partOrCustomerModel";


const models = {
    global,
    nav,
    menuState,
    material,
    warehouse,
    supplier,
    customer,
    dict,
    cmDict,
    purchaseOrder,
    purchaseInvoice,
    purchasePo,
    purchaseRo,
    saleOrder,
    saleSo,
    saleRo,
    stockStatistic,
    stockCheck,
    supplierBill,
    customerBill,
    partDealModel,
    dinoutModel,
    customerSaleModel,
    supplierModel,
    partOrCustomerModel
}

const store = createStore(models);
/*
Provider,
useModel,
getModel,
withModel,
// auxiliary API
useModelDispatchers,
useModelEffectsState,
withModelDispatchers,
withModelEffectsState,
getModelState,
getModelDispatchers
*/

export default store;
export const { Provider, useModel, useModelDispatchers, useModelEffectsState, getModelState, getModelDispatchers } = store;
